import { createStyles, makeStyles } from '@material-ui/styles'
import { Theme } from '@material-ui/core'

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    content: {
      '@media print': {
        marginTop: 0
      },

      [theme.breakpoints.down('sm')]: {
        marginTop: '4.5rem'
      },
      width: '100%',
      minHeight: 'calc(100vh - 5rem)',
      display: 'flex',
      flexDirection: 'column'
    },
    marginLayout: {
      marginTop: '6.5rem'
    }
  })
)
